export enum TipoPeriodoEnum {

  esporadico = "Esporádico",
  mensal = "Mensal"
}
